export default "__VITE_ASSET__BfJeMzea__"